import { getUserProfile } from "../services/usersService";

export const SET_LOGGED_IN_USER_PROFILE = "SET_LOGGED_IN_USER_PROFILE";
export const LOAD_LOGGED_IN_USER_PROFILE = "LOAD_LOGGED_IN_USER_PROFILE";

export function loggedInUserProfile(store) {
  store.on("@init", () => {
    return {
      loggedInUserProfile: {
        accountType: "Freemium",
        name: "",
        last_name: "",
        email: "",
        id: null,
      },
    };
  });

  store.on(
    LOAD_LOGGED_IN_USER_PROFILE,
    async ({ auth }, { access_token, id }) => {
      try {
        const userProfile = localStorage.getItem("loggedInUser");
        const userProfileObj = userProfile && JSON.parse(userProfile);

        if (userProfileObj) {
          const res = await getUserProfile(
            { access_token: auth.access_token },
            id
          );
          store.dispatch(SET_LOGGED_IN_USER_PROFILE, {
            profile: res,
          });
        } else {
          const res = await getUserProfile({ access_token: access_token }, id);
          store.dispatch(SET_LOGGED_IN_USER_PROFILE, { profile: res });
        }
      } catch (error) {
        console.log(error);
      }
    }
  );

  store.on(
    SET_LOGGED_IN_USER_PROFILE,
    ({ loggedInUserProfile }, { profile }) => {
      localStorage.setItem(
        "loggedInUser",
        JSON.stringify({
          ...profile,
          role: profile.role,
          accountType: profile.accountType,
        })
      );
      return {
        loggedInUserProfile: {
          ...profile,
        },
      };
    }
  );
}
